const UmrahPackages = () => {
    return (
        <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Umrah Packages
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        An extensive global network built over decades, has earned TCS a unique position in providing 
                        the best hospitality to pilgrims who travel to holy lands. Going the extra mile in facilitating 
                        customers to meet their travel related needs, TCS Travel & Tours offers exclusive, customised 
                        packages to suit the budgets of its customers catering to all segments of the market. 
                        TCS Umrah packages include visas, airline tickets, insurance, hotels, transport and Ziaraat.
                    </p>
                   
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/Intiana/umrah.jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
};
export default UmrahPackages;